import { render, staticRenderFns } from "./createExamDialog.vue?vue&type=template&id=0b5c7627&scoped=true"
import script from "./createExamDialog.vue?vue&type=script&lang=js"
export * from "./createExamDialog.vue?vue&type=script&lang=js"
import style0 from "./createExamDialog.vue?vue&type=style&index=0&id=0b5c7627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c7627",
  null
  
)

export default component.exports